import type { RouteObject } from 'react-router-dom';

import { AppShellProviders } from '@/components/common/AppShellProviders';
import { AppLayout } from '@/components/layout/AppLayout';
import { ProtectedRoute } from '@/features/auth/ProtectedRoute';

import { OrgProjectsPage } from './pages/OrgProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';

/**
 * Projects feature routes (flat glob registry — `src/features/registry.ts`).
 *
 * Design §5.1 nests these under the organizations layout route, but the registry
 * is flat and each protected feature owns its own tree, so this tree declares the
 * same `/organizations/:orgId` prefix and its pages render the shared
 * `OrgDetailHeader` themselves. React Router only accepts a branch that matches
 * the whole pathname, so `/organizations/x/members` still resolves to the orgs
 * tree and `/organizations/x[/projects…]` to this one — the two never collide.
 *
 * No top-level `nav.ts` here: P1 ships exactly two sidebar entries (design §6),
 * and projects are always reached through their organization.
 */
export const routes: RouteObject[] = [
  {
    path: '/organizations/:orgId/projects',
    element: (
      <ProtectedRoute>
        <AppShellProviders>
          <AppLayout />
        </AppShellProviders>
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <OrgProjectsPage /> },
      { path: ':projectId', element: <ProjectDetailPage /> },
    ],
  },
];
